import { render, staticRenderFns } from "./ReservationDetails.vue?vue&type=template&id=8bc56dfc&scoped=true&"
import script from "./ReservationDetails.vue?vue&type=script&lang=ts&"
export * from "./ReservationDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ReservationDetails.vue?vue&type=style&index=0&id=8bc56dfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc56dfc",
  null
  
)

export default component.exports